import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { nextPaginationData, paginationByNumber } from '../Redux/Slice/DataSlice'


const Pagination = () => {
	const {PaginationNumber}=useSelector((state)=>state.CarData)
	const dispatch=useDispatch()
	let No_Cars=2
	const [Lower, setLower] = useState(0)
	const [Upper, setUpper] = useState(No_Cars)
	const [Pages, setPages] = useState()
	

	const NextData=()=>{
		dispatch(nextPaginationData({Lower:Lower,Upper:Upper}))
		if(PaginationNumber*2>Upper){
		setLower(Lower+No_Cars)
		setUpper(Upper+No_Cars)
		console.log(Lower,Upper)
		}
		console.log(Lower,Upper)
	}
	

	const PreviousData=()=>{
		if(Lower>0){
			setLower(Lower-No_Cars)
			setUpper(Upper-No_Cars)
		}else{
			setLower(0)
			setUpper(No_Cars)	
		}
		dispatch(nextPaginationData({Lower:Lower,Upper:Upper}))
	}
	let page=[]

	useEffect(() => {
	if(page.length===0){
		for(let x =1;x<=PaginationNumber;x++){
			page=[...page,x]	
		}
		setPages(page)
	}	
	}, [PaginationNumber])

	
	
	
  return (
    <div className='h-[10vh] w-[100%] flex justify-center items-start my-5'>
        	<ul class="inline-flex -space-x-px">
			<li onClick={PreviousData} className='bg-white border border-gray-300 text-gray-500 hover:bg-gray-100 hover:text-gray-700 ml-0 rounded-l-lg leading-tight py-2 px-3 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white'>
				Previous
			</li>
			{
				Pages && Pages.map((x,index)=>{
					return(
						<li onClick={()=>dispatch(paginationByNumber(x))} className='bg-white border border-gray-300 text-gray-500 hover:bg-gray-100 hover:text-gray-700 leading-tight py-2 px-3 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white' key={index}>
					{x}
					</li>
				
					)

				})
				
			}

			<li onClick={NextData} class="bg-white border border-gray-300 text-gray-500 hover:bg-gray-100 hover:text-gray-700 rounded-r-lg leading-tight py-2 px-3 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
			Next
			</li>
		</ul>
    </div>
  )
}

export default Pagination